import { z } from 'zod';

/**
 * What a `fee` product is **for** — the coded catalogue of one-off charges.
 *
 * A purpose is a contract between billing and exactly one other module: billing
 * settles the payment and announces it, and the module the prefix names is the
 * only reader that acts on it (`verification.interview` → the interview step's
 * ticket). A purpose nobody consumes is a product that takes money for nothing,
 * so the list is coded rather than staff-typed, the way `INTEGRATION_CAPABILITIES`
 * is.
 */
export const FEE_PURPOSES = ['verification.interview'] as const;

export const FeePurposeSchema = z.enum(FEE_PURPOSES);

export type FeePurpose = (typeof FEE_PURPOSES)[number];

const PURPOSE_SET: ReadonlySet<string> = new Set(FEE_PURPOSES);

export function isFeePurpose(value: string): value is FeePurpose {
  return PURPOSE_SET.has(value);
}
